import { Divider as DividerC, type DividerProps } from '@chakra-ui/react'

export default function Divider(props: DividerProps): JSX.Element {
  return <DividerC borderTopWidth="2px" borderColor="border.muted" {...props} />
}
